import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import * as lodash from 'lodash'
import { availableFieldFonts, RoleColor } from '../constants'
import { Destroyable, untilDestroy, User, userFullname } from '@tokeet-frontend/tv3-platform'

export function createFieldSettingForm(fb: FormBuilder) {
  return fb.group({
    label: [undefined, [Validators.required]],
    role: [undefined, [Validators.required]],
    value: [],
    required: [],
    font: [],
    font_size: [],
    fill_before_sent: [],
    prefill_data_id: [],
    readonly: [],
  })
}

@Component({
  selector: 'app-field-setting-form',
  templateUrl: './field-setting-form.component.html',
  styleUrls: ['./field-setting-form.component.scss'],
})
export class FieldSettingFormComponent extends Destroyable implements OnInit {
  @Input() form: FormGroup

  @Input() roles: RoleColor[] = []
  @Input() isRoleEditable: boolean
  @Input() isCustomField: boolean
  @Input() isValueCustomizable: boolean
  @Input() isRequiredEditable: boolean
  @Input() isEditableGuestDataDictField: boolean
  @Input() disableCustomFont: boolean
  @Input() prefillType: string

  @Output() role = new EventEmitter<string>()

  fonts = availableFieldFonts
  fontSizes = lodash.range(10, 21)

  get fillBeforeSentCtrl() {
    return this.form?.get('fill_before_sent')
  }

  constructor() {
    super()
  }

  ngOnInit(): void {
    this.fillBeforeSentCtrl.valueChanges.pipe(untilDestroy(this)).subscribe((value) => {
      const labelCtrl = this.form.get('label')
      if (value) {
        labelCtrl.setValidators([Validators.required])
      } else {
        labelCtrl.setValidators([])
      }
      labelCtrl.markAllAsTouched()
      labelCtrl.updateValueAndValidity()
    })
  }

  onPrefillUserSelected([user]: User[]) {
    this.form.patchValue({ value: userFullname(user) })
  }

  onRoleChange([role]: string[]) {
    this.role.emit(role)
  }
}
